<template>
  <v-row>
    <v-col>
      <DocumentCategory :id="90000" />
    </v-col>
    <v-col>
      <DocumentCategory :id="94000" />
    </v-col>
  </v-row>
</template>

<script>
import { defineComponent } from "vue";
import DocumentCategory from "@/components/DocumentCategory.vue";
export default defineComponent({
  components: { DocumentCategory },
  data() {
    return {
      items: [],
      loading: false,
    };
  },
});
</script>
